<template>
  <form autocomplete="off" class="form" v-on:submit.prevent="submit(password)">
    <div class="flex form-row">
      <div class="col-12">
        <label for="username">Email <span>*</span></label>
        <input
            id="username"
            type="email"
            placeholder="Email"
            name="email"
            disabled="disabled"
            v-model="user.email"
            v-validate="'required'"
        >
        <span v-if="errors.has('email')">{{ errors.first('email') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-12">
        <label for="username">Password <span>*</span></label>
        <input
            id="password"
            type="password"
            placeholder="Password"
            name="password"
            v-model="password"
            v-validate="'required'"
        >
        <span v-if="errors.has('password')">{{ errors.first('password') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-12">
        <button class="body-8 btn" :disabled="pending || errors.any()">Submit</button>
        <router-link class="log-1 text-grey-1 hover:text-grey-2 float-right mt-8" :to="{ name: 'forgot-password' }">Forgot my password</router-link>
      </div>
    </div>
  </form>
</template>

<script>
  export default {
    name: 'AdminLoginForm',

    props: ['user', 'authErrors', 'pending'],

    data: function () {
      return {
        password: null
      }
    },

    computed: {
      passwordField: function () {
        return this.$validator.fields.find({ name: 'password', scope: this.$options.scope });
      }
    },

    watch: {
      authErrors: function(newErrors) {
        if (newErrors.length) {
          this.$validator.errors.add({
            id: this.passwordField.id,
            field: 'password',
            msg: newErrors,
            scope: this.$options.scope,
          });

          this.passwordField.setFlags({
            invalid: true,
            valid: false,
            validated: true,
          });
        }
      }
    },

    methods: {
      submit: function (password) {
        this.$validator.validateAll()
            .then((valid) => {
              if (valid) {
                const email = this.user.email;
                this.$emit('submit', {email, password});
              }
            });
      }
    }
  }
</script>